import { StyledElement, defineElement } from '@webtides/element-js';
import style from './tab-nav.css';

/**
 * @property {string} variant - 'links' or 'buttons'
 * @property {string} selected - Currently selected tab name
 * @property {TabRegisterStore} tabRegisterStore
 */
export default class TabNav extends StyledElement {
    constructor() {
        super({ styles: [style], propertyOptions: { variant: { reflect: true } } });
    }

    properties() {
        return {
            variant: 'links',
            selected: undefined,
        };
    }

    injectProperties() {
        return {
            /** @type {TabRegisterStore} */
            tabRegisterStore: (tabRegisterStore) => {
                tabRegisterStore.register('nav', this);
            },
        };
    }

    connected() {
        this.setAttribute('role', 'tablist');
    }

    disconnected() {
        this.tabRegisterStore?.unregister('nav', this);
    }

    watch() {
        return {
            selected: () => {
                this.scrollToSelected();
            },
        };
    }

    scrollToSelected() {
        const selectedLink = this.querySelector(`mb-tab-link[for="${this.selected}"]`);
        if (!selectedLink) return;

        const scrollContainer = this.closest('mb-scroller') || this;

        const distance = selectedLink.previousElementSibling
            ? selectedLink.getBoundingClientRect().left - scrollContainer.getBoundingClientRect().left - 20
            : 0;

        scrollContainer.scrollTo({
            top: 0,
            left: distance,
            behavior: 'smooth',
        });
    }
}

defineElement('mb-tab-nav', TabNav);
